import { ArrowUpRight, CalendarDays, FileText, MapPin, Star } from "lucide-react";
import { CONTACT } from "./data";

const Item = ({ icon: Icon, label, title, text, testId, children }) => (
  <li
    className="group flex min-h-[178px] items-start gap-3 bg-paper px-4 py-6 sm:gap-5 sm:px-7 lg:px-8 lg:py-8 xl:px-6 2xl:px-8"
    data-testid={testId}
  >
    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#efede6] text-moss transition-transform duration-300 group-hover:-translate-y-1 sm:h-14 sm:w-14">
      <Icon size={25} strokeWidth={1.55} aria-hidden="true" />
    </div>
    <div className="min-w-0 pt-1">
      <p className="text-[0.62rem] font-semibold uppercase tracking-[0.13em] text-ink3 sm:text-[0.67rem] sm:tracking-[0.19em]">{label}</p>
      {children || <p className="mt-3 font-display text-[1.6rem] leading-[1.05] text-ink sm:text-[1.75rem]">{title}</p>}
      <p className="mt-3 max-w-[240px] text-sm leading-relaxed text-ink3">{text}</p>
    </div>
  </li>
);

export const TrustRow = () => (
  <section
    aria-label="Kort om Folkare Bygg"
    className="relative z-20 mt-0 px-5 sm:-mt-8 sm:px-8 lg:-mt-12 lg:px-12"
    data-testid="trust-row"
  >
    <ul className="mx-auto grid max-w-[1440px] gap-px overflow-hidden rounded-[22px] border border-line/80 bg-line/80 shadow-[0_18px_55px_rgba(31,36,40,0.10)] sm:grid-cols-2 xl:grid-cols-4">
      <Item
        icon={CalendarDays}
        label="Etablerat"
        title="Sedan 2008"
        text="Byggt lokalt i Folkarebygden sedan 2008."
        testId="trust-since"
      />

      <Item
        icon={Star}
        label="Kundbetyg"
        text="Betyg från kunder."
        testId="trust-dorunner"
      >
        <div className="mt-3">
          <span className="block font-display text-[1.6rem] leading-[1.05] text-ink sm:text-[1.75rem]">5 av 5</span>
          <span className="mt-2 block font-sans text-[0.9rem] tracking-[0.08em] text-[#C79A2B]" aria-label="5 av 5 stjärnor">★★★★★</span>
          <a
            href={CONTACT.dorunner}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-moss underline-offset-4 hover:underline"
            data-testid="trust-dorunner-link"
          >
            Läs omdömena
            <ArrowUpRight size={13} strokeWidth={1.8} aria-hidden="true" />
            <span className="sr-only"> (öppnas i ny flik)</span>
          </a>
        </div>
      </Item>

      <Item
        icon={FileText}
        label="Första steget"
        title="Kostnadsfri offert"
        text="Vi tittar på projektet och ger en tydlig offert."
        testId="trust-offert"
      />

      <Item
        icon={MapPin}
        label="Verksamhetsområde"
        title="Avesta med omnejd"
        text="Uppdrag även i Sala, Hedemora och Säter."
        testId="trust-area"
      />
    </ul>
  </section>
);
